module.exports = __webpack_public_path__ + "img/eye.4840b025.svg";